// @auto-index

import Paragraph from './Paragraph'

export { default as Paragraph } from './Paragraph'

export default Paragraph
